import { call, put, takeLatest } from 'redux-saga/effects';
import {
  CASE_FETCH_ARTEFACT_BEGIN,
  CASE_FETCH_ARTEFACT_SUCCESS,
  CASE_FETCH_ARTEFACT_FAILURE,
  CASE_FETCH_ARTEFACT_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from '../../../common/selectors';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';

export const fetchArtefact = createPromiseAction(CASE_FETCH_ARTEFACT_BEGIN);

export function dismissFetchArtefactFeedback() {
  return {
    type: CASE_FETCH_ARTEFACT_DISMISS_FEEDBACK,
  };
}

export function* doFetchArtefact(action) {
  const {
    payload: { caseId, artefactType },
  } = action;
  const res = yield call(api.get, `/cases/${caseId}/artefacts/${artefactType}`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_ARTEFACT_FAILURE,
      feedback: {
        message: 'feedback.fetchArtefactFailure',
        error: res.error,
      },
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_ARTEFACT_SUCCESS,
    data: res,
  });
  yield call(resolvePromiseAction, action, res);
}

export function* watchFetchArtefact() {
  yield takeLatest(fetchArtefact, withCurrentCaseId(doFetchArtefact));
}

export function useFetchArtefact() {
  const dispatch = useDispatch();

  const { selectedArtefact, selectedArtefactPending, selectedArtefactFeedback } = useSelector(
    (state) => ({
      selectedArtefact: state.case.selectedArtefact,
      selectedArtefactPending: state.case.selectedArtefactPending,
      selectedArtefactFeedback: state.case.selectedArtefactFeedback,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(fetchArtefact(...args));
    },
    [dispatch],
  );

  const boundDismissFeedback = useCallback(() => {
    return dispatch(dismissFetchArtefactFeedback());
  }, [dispatch]);

  return {
    selectedArtefact,
    fetchArtefact: boundAction,
    selectedArtefactPending,
    selectedArtefactFeedback,
    dismissFetchArtefactFeedback: boundDismissFeedback,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_ARTEFACT_BEGIN + '.TRIGGER':
      return {
        ...state,
        selectedArtefactPending: true,
        selectedArtefactFeedback: null,
      };

    case CASE_FETCH_ARTEFACT_SUCCESS:
      return {
        ...state,
        selectedArtefactPending: false,
        selectedArtefactFeedback: action.feedback,
        selectedArtefact: action.data,
      };

    case CASE_FETCH_ARTEFACT_FAILURE:
      return {
        ...state,
        selectedArtefactPending: false,
        selectedArtefactFeedback: action.feedback,
      };

    case CASE_FETCH_ARTEFACT_DISMISS_FEEDBACK:
      return {
        ...state,
        selectedArtefactFeedback: null,
      };

    default:
      return state;
  }
}
